import { Event as TEvent } from "../../../Global/Base/Events";
import { Edit } from "../../UI.BaseControls/Edit";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuInputItem extends DropDownMenuItem {
    /** událost vyvolaná změnou Editu */
    public inputChanged: TEvent<string, void> = new TEvent<string, void>();
    private _withIcon: boolean;
    private _inputValue: string;
    public editField: Edit;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    constructor(inputValue?: string, withIcon?: boolean) {
        super();

        this.classList.add("ComboboxItem");
        this.visible = true;
        if (inputValue)
            this._inputValue = inputValue;
        withIcon ? this._withIcon = true : this._withIcon = false;

        this._createThisElement();
    }

    protected _createThisElement(): void {
        this.classList.add("DropDownMenuItem", "SecondCaptionItem", "ComboboxItem");
        const container = createElement({ type: "div", classes: "container", css: { display: "block", padding: "0px", height: "25px" } });
        this.editField = new Edit();
        this.editField.onchange = () => {
            this._inputOnChange();
        };
        if (this._inputValue) {
            this.editField.value = this._inputValue;
        }
        container.appendChild(this.editField);

        if (this._withIcon) {
            this._createIconElement();
            this.appendChild(this._iconElement);
        }

        this.appendChild(container);
    }

    protected override _createElement(): void {
        // Prazdna metoda
    }

    protected override _setListener(): void {
        // Prazdna metoda
    }

    /**
     * akce vyvolaná změnou _menuEdit
     * nový název promítne na záznam svislé osy a do chartsettingsmanageru
     * @param newElement Obsah _menuEdit
     */
    private _inputOnChange(): void {
        this.inputChanged.trigger(this.editField.value, null);
    }

    public finallyDispose(): void {
        this.editField.unregisterEventListener();
        this.editField.dispose();
        this.unregisterEventListener();
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuInputItem", DropDownMenuInputItem);
